export const ROUTE_PATH = '/settings';

export const SECTION_ROUTE_PATH = '/settings/:section';

export const FEATURE_NAME = 'settingsPage';
